import styled from 'styled-components';

// TODO Move to ui-kit
const IconLink = styled.a`
    width: 48px;
    height: 48px;
    display: grid;
    place-items: center;
    transition: 0.3s ease-out box-shadow;
    box-shadow: inset 0 0 0 0 currentColor;
    &:focus-visible {
        box-shadow: inset 0 0 0 2px currentColor;
    }
`;

const HeaderIconLink = styled(IconLink)`
    color: ${({ theme }) => theme.colors.charcoal100};
    &:hover,
    &:focus {
        color: ${({ theme }) => theme.colors.charcoal50};
    }
`;

export default HeaderIconLink;
